export default "/images/certificate2.png?bbeb9fea81c553574eec0336be1030a9";